import {
  RECEIVE_MESSAGE_THREADS,
  RECEIVE_CURRENT_THREAD,
  RECEIVE_THREAD_MESSAGES,
  RECEIVE_MESSAGE,
  SET_ACTIVE_THREAD,
  CLEAR_THREAD_UNREAD,
  SET_THREAD_UNREAD,
  INCREMENT_THREAD_UNREAD,
  INCREMENT_STUDENT_UNREAD,
  CLEAR_STUDENT_UNREAD,
  RECEIVE_MESSAGE_REACTION,
  // 🆕 explicit setter for student unread
  SET_STUDENT_UNREAD,
} from '../actions/messages_actions';

const initialState = {
  threads: [],
  currentThread: null,
  activeThreadId: null,
  messagesByThread: {},
  lastSeenByThread: {},
  studentUnreadCount: 0,
};

const messagesReducer = (state = initialState, action) => {
  Object.freeze(state);

  switch (action.type) {
    case RECEIVE_MESSAGE_THREADS:
      return {
        ...state,
        threads: action.threads || [],
      };

    case RECEIVE_CURRENT_THREAD:
      return {
        ...state,
        currentThread: action.thread,
        // 📌 Don't touch studentUnreadCount here anymore.
        // We'll hydrate it via SET_STUDENT_UNREAD so it’s explicit.
      };

    case SET_ACTIVE_THREAD:
      return {
        ...state,
        activeThreadId: action.threadId,
        lastSeenByThread: {
          ...state.lastSeenByThread,
          [action.threadId]: new Date().toISOString(),
        },
      };

    case RECEIVE_THREAD_MESSAGES: {
      const { threadId, messages } = action;
      return {
        ...state,
        messagesByThread: {
          ...state.messagesByThread,
          [threadId]: messages || [],
        },
      };
    }

    // 🔥 both normal messages AND reactions come through here
    case RECEIVE_MESSAGE:
    case RECEIVE_MESSAGE_REACTION: {
      const msg = action.message;
      if (!msg || !msg._id || !msg.thread) return state;

      const threadId =
        typeof msg.thread === 'string' ? msg.thread : msg.thread._id;

      const existing = state.messagesByThread[threadId] || [];
      const idx = existing.findIndex(
        (m) => String(m._id) === String(msg._id)
      );

      let newThreadMessages;
      if (idx === -1) {
        // New message → append
        newThreadMessages = [...existing, msg];
      } else {
        // Updated message (reaction, edits, etc) → replace
        newThreadMessages = [...existing];
        newThreadMessages[idx] = msg;
      }

      return {
        ...state,
        messagesByThread: {
          ...state.messagesByThread,
          [threadId]: newThreadMessages,
        },
      };
    }

    case CLEAR_THREAD_UNREAD:
      return {
        ...state,
        threads: state.threads.map((t) =>
          String(t._id) === String(action.threadId)
            ? { ...t, unreadCount: 0 }
            : t
        ),
      };
    case SET_THREAD_UNREAD:
      return {
        ...state,
        threads: state.threads.map((t) =>
          String(t._id) === String(action.threadId)
            ? { ...t, unreadCount: action.count }
            : t
        ),
      };

    case INCREMENT_THREAD_UNREAD:
      return {
        ...state,
        threads: state.threads.map((t) =>
          String(t._id) === String(action.threadId)
            ? { ...t, unreadCount: (t.unreadCount || 0) + 1 }
            : t
        ),
      };

    case INCREMENT_STUDENT_UNREAD:
      return {
        ...state,
        studentUnreadCount: state.studentUnreadCount + 1,
      };

    case CLEAR_STUDENT_UNREAD:
      return {
        ...state,
        studentUnreadCount: 0,
      };

    // 🆕 hydrate from server (e.g. unreadCountStudent on /my-thread)
    case SET_STUDENT_UNREAD:
      return {
        ...state,
        studentUnreadCount:
          typeof action.count === 'number' ? action.count : 0,
      };

    default:
      return state;
  }
};

export default messagesReducer;
